import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../UserContext/UserContext';
import { SHIPMENT_URLS } from '../../config/routeUrls';
import logo from '../../static/logo.png';
import './navbar.css';
import NavbarLoginComponent from '../NavbarLoginComponent/NavbarLoginComponent';

export default function Navbar() {
  const location = useLocation();
  const { userContext } = useContext(UserContext);

  const isAuthenticated = userContext !== null && userContext.isAuthenticated;

  const getLinkClassName = page_name => {
    if (page_name === 'controle' && location.pathname === '/') {
      return 'nav-item current';
    }
    if (location.pathname.includes(page_name)) {
      if (!(page_name === '/clients' && location.pathname.includes('stats'))) {
        return 'nav-item current';
      }
    }
    return 'nav-item';
  };

  return (
    <div>
      <nav className="navbar">
        <div className="logo">
          <a href="/">
            <img src={logo} alt="Logo"></img>
          </a>
        </div>
        <div className="separator"></div>
        {isAuthenticated && (
          <ul className="nav-links">
            <a className={getLinkClassName('controle')} href="/">
              <li>Contrôle</li>
            </a>
            <a className={getLinkClassName('/dossiers')} href={SHIPMENT_URLS.EN_COURS}>
              <li>Dossiers</li>
            </a>
            <a className={getLinkClassName('/factures')} href="/factures">
              <li>Facturation clients</li>
            </a>
            <a
              className={getLinkClassName('/facturation-tps')}
              href="/facturation-tps?carrier_has_been_paid=false"
            >
              <li>Facturation tps</li>
            </a>
            <a className={getLinkClassName('/clients')} href="/clients">
              <li>BDD Clients</li>
            </a>
            <a className={getLinkClassName('/transporteurs')} href="/transporteurs">
              <li>BDD Transporteurs</li>
            </a>
            <a className={getLinkClassName('/stats')} href="/stats/ca-marge">
              <li>Stats</li>
            </a>
          </ul>
        )}
        <ul className="right-section">
          <NavbarLoginComponent />
        </ul>
      </nav>
    </div>
  );
}
